<template>
  <div class="banner" :style="bannerData.bg">
    <div class="container">
      <h1>{{bannerData.text.title}}</h1>
      <!-- <h5>
        工信部：2020年新增上云企业20000多家
        <br />《推动企业上云实施指南( 2018 2019 )》
      </h5>-->
      <h3 v-for="(item,index) in bannerData.text.subtitle" :key="index">{{item}}</h3>
      <span class="br"></span>
      <h5 v-for="(item,index) in bannerData.text.content" :key="index+'ct'">{{item}}</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "customer",
  props: {
    msg: String
  },
  data() {
    return {
      bannerData: {
        bg: `background:url(${require("../assets/images/getech/banner.jpg")}) no-repeat scroll top center/auto 100%;`,
        text: {
          title: "飞讯平台演示中心",
          // subtitle: ["聚焦生产现场 成就新一代“工业极客”"],
          content: [
            "飞讯软件成立于2006年，自成立以来一直专注于构件式开发平台的研发，并基于平台实现精益智能工厂一站式DIY信息化解决方案，为了让大家方便了解平台，本演示中心提供了以下服务：","1、系统演示，产品展示，样式库，应用下载。","2、扫企业微信二维码，加入飞讯软件，了解公司动态。扫QQ培训群二维码，在群内反馈提问，让专业的老师答疑解惑。","3、点击相关的操作文档链接，系统掌握平台相关知识。点击学习视频，观看专业的视频教程。"
          ]
        }
      }
    };
  },
  created(){

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.module-title {
  text-align: center;
}
</style>
